// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JC4NTIeSxyID7V_U6oxG button:empty{display:none}p.fWZIKbQiq2PLNRz7tnqK{margin-bottom:0}`, "",{"version":3,"sources":["webpack://./../../mfe/credit-verification/src/components/CAEModal/cae.module.scss"],"names":[],"mappings":"AACE,mCACE,YAAA,CAIJ,uBACE,eAAA","sourcesContent":[".modal {\n  button:empty {\n    display: none;\n  }\n}\n\np.bodyText {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `JC4NTIeSxyID7V_U6oxG`,
	"bodyText": `fWZIKbQiq2PLNRz7tnqK`
};
export default ___CSS_LOADER_EXPORT___;
